import { ErrorState, IconTitle, InformationBlock, Loading } from '@dec/shared';
import {
  Calendar2,
  CurrencyExchange,
  FileBarGraph,
  type Icon,
  Person
} from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { useDisbursementStats } from '../hooks/useDisbursementStats';

interface StatValue {
  title: string;
  type: 'number' | 'date' | 'text';
  value: number | string | Date | undefined;
  icon?: Icon;
}

export const DisbursementStatsCard = () => {
  const { t } = useTranslation();
  const { data: stats, isLoading, error, refetch } = useDisbursementStats();

  const info: Array<StatValue> = [
    { type: 'number', value: stats?.count, title: t('dashboard.payments'), icon: Person },
    {
      type: 'number',
      value: stats?.taxpayers,
      title: t('dashboard.taxpayers'),
      icon: CurrencyExchange
    },
    {
      type: 'date',
      value: stats?.firstPayment,
      title: t('dashboard.firstPayment'),
      icon: Calendar2
    },
    { type: 'date', value: stats?.lastPayment, title: t('dashboard.lastPayment'), icon: Calendar2 }
  ];

  return (
    <div className="card">
      <div className="card-header bg-soft">
        <IconTitle
          title={t('dashboard.statistics')}
          icon={FileBarGraph}
          subtitle={t('dashboard.jurisdictions')}
        />
      </div>

      <div className="card-body">
        {isLoading && <Loading />}

        {error && <ErrorState onRetry={() => void refetch()} />}

        {!isLoading && !error && (
          <div className="row row-cols-2 row-cols-md-2 row-cols-lg-4 row-cols-xl-4 g-5">
            {(info ?? []).map((item) => (
              <div className="col" key={item.title}>
                <InformationBlock
                  title={item.title}
                  value={item.value}
                  type={item.type}
                  icon={item.icon}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
